import React from 'react';
import IImage from '../../../models/viewModels/base/IImage';
import breakpoints from '../../../styles/partials/breakpoints.module.scss';
import IVideo from '../../../models/viewModels/base/IVideo';
import { Breakpoint } from '../../../constants/breakpoints';

const breakpointDesktop = Breakpoint.Large - 1;
const breakpointTabletLandscape = parseInt(breakpoints.tablet_landscape, 10) - 1;

export default function getMediaGallerySettings(galleryItems: Array<IImage | IVideo>) {
  return {
    mainSliderSettings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: `.slider-nav`,
      lazyLoad: `ondemand`,
      infinite: galleryItems.length >= 5,
      responsive: [
        {
          breakpoint: breakpointTabletLandscape,
          settings: {
            slidesToShow: 1,
            infinite: galleryItems.length > 4,
          },
        },
        {
          breakpoint: breakpointDesktop,
          settings: {
            slidesToShow: 1,
            infinite: galleryItems.length > 3,
          },
        },
      ],
    },
    thumbSliderSettings: {
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: `.slider-for`,
      dots: true,
      centerMode: true,
      swipeToSlide: true,
      focusOnSelect: true,
      centerPadding: `0px`,
      lazyLoad: galleryItems.length > 5 ? `ondemand` : false,
      arrows: true,
      infinite: galleryItems.length >= 5,
      responsive: [
        {
          breakpoint: breakpointTabletLandscape,
          settings: {
            slidesToShow: 4,
            infinite: galleryItems.length > 4,
          },
        },
        {
          breakpoint: breakpointDesktop,
          settings: {
            slidesToShow: 3,
            infinite: galleryItems.length > 3,
          },
        },
        {
          breakpoint: Breakpoint.Medium,
          settings: {
            slidesToShow: 3,
            infinite: galleryItems.length > 3,
            arrows: false,
          },
        },
        {
          breakpoint: Breakpoint.Small,
          settings: {
            slidesToShow: 3,
            infinite: galleryItems.length > 3,
            arrows: false,
          },
        },
      ],
    },
  };
}
